import { DialogTitle, DialogTitleProps, styled } from '@mui/material';
import { FC } from 'react';

export const SimpleDialogTitle = styled(DialogTitle as FC<DialogTitleProps>)(() => ({
	fontSize: '1.25rem',
	fontWeight: 600,
	width: '100%',
	textAlign: 'center'
}));
